export default {
	header: {
		display: 'flex',
		padding: 10,
		backgroundColor: '#fff',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	headerItem: {
		marginLeft: '2rem',
		color: '#f0f0f0',
		borderColor : '#eb1c09',
		textshadow: 'none',
		backgroundColor: '#eb1c09'
	}
};
